/* eslint-disable react/prop-types */
import React from 'react';
import {
  Grid, Typography, Box,
} from '@material-ui/core';
import PlayIcon from '@material-ui/icons/PlayArrow';
import HeartIcon from '@material-ui/icons/Favorite';
import NumberFormatter from '@shared/utils/NumberFormatter';

import './VideoCard.css';

function VideoCard({ klip, customWidth }) {
  const renderInfo = (klipItem) => (
    <Box
      className='klip-info'
      key={klipItem.feed_id}
    >
      <Typography
        style={{
          fontWeight: 900,
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          fontFamily: 'CircularXX-Book',
          fontSize: 16,
          overflow: 'hidden',
        }}
      >
        {klipItem.content}
      </Typography>
      <Typography
        style={{
          textOverflow: 'ellipsis',
          fontFamily: 'CircularXX-Book',
          fontWeight: 400,
          whiteSpace: 'nowrap',
          fontSize: 16,
          overflow: 'hidden',
        }}
      >
        {(klipItem.tags.join(' '))}
      </Typography>
    </Box>
  );

  return (
    <div
      className='klips-item'
      style={{
        backgroundImage: `url(${klip.image_url[0].image})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: customWidth ? '100%' : '90%',
      }}
    >
      <div className='heart-count'>
        <Grid container alignItems='center' justifyContent='center'>
          <HeartIcon style={{ fontSize: 20, color: '#fff' }} />
            &nbsp;
          <Typography style={{ fontSize: '14px' }}>{NumberFormatter(klip.like_count, 1)}</Typography>
        </Grid>
      </div>
      <div className='klip-content'>
        <div className='klip-play'>
          <div className='icon'>
            <PlayIcon style={{ color: '#fff', fontSize: 70, borderRadius: 5 }} />
          </div>
        </div>
        {klip ? renderInfo(klip) : null}
      </div>
    </div>
  );
}

export default VideoCard;
